// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2b_8p","bigColWidth":"Table_bigColWidth__3-qNy","biggerColWidth":"Table_biggerColWidth__1yVeS","row":"Table_row__3siQL","col":"Table_col__1nw_B"};